<script setup>

import { onMounted, ref } from 'vue'
import rentingService from '@/services/renting.service'
import referenceIndexService from '@/services/referenceIndex.service'
import Icon from '@/components/Icon/Icon.vue'
import ProgressSpinner from 'primevue/progressspinner'
import ReferenceIndexWidgetEditModal from '@/components/modal/ReferenceIndexWidgetEditModal.vue'
import { useDataStore } from '@/store/data.store'
import taskService from '@/services/task.service'

const loading = ref(false)
const reference_indexes = ref([])
const renting = ref({})
const referenceIndex = ref({})
const referenceIndexes = ref([])
const newRI = ref({})
const referenceIndexEditDialog = ref(false)
const referenceIndexToEdit = ref({})
const dataStore = useDataStore()

const props = defineProps({
    data: {
        active: Object,
        required: true,
    }
})

const emit = defineEmits(['changeTask'])

const updateReferenceIndex = (data) => {
    rentingService.updateReferenceIndex(data.tri.renting_uuid, {
        reference_index: newRI.value.id,
        round_rent: data.roundRent,
    }).then(() => {
        referenceIndexes.value.find((o, i) => {
            if(o.uuid === data.uuid) {
                referenceIndexes.value.splice(i, 1)

                return true
            }
        })

        taskService.modify(data.uuid, {
            status: 1
        })
        .then(() => {
            props.data.status = 1

            emit('changeTask', data.uuid)
        })
    })
}

const editReferenceIndex = (data) => {
    referenceIndexToEdit.value = {...data}
    referenceIndexToEdit.value.id = newRI.value.id

    referenceIndexEditDialog.value = true
}

const editReferenceIndexEnd = (data) => {
    referenceIndexes.value.find((o, i) => {
        if(o.uuid === data.tri.renting_uuid) {
            const found = referenceIndexes.value.find((o, i) => {
                if(o.id == data.id) {
                    return true
                }
            })

            newRI.value = found
            data.roundRent = data.roundRent

            return true
        }
    })

    updateReferenceIndex(data)

    taskService.modify(data.uuid, {
        status: 1
    })
    .then(() => {
        props.data.status = 1

        emit('changeTask', data.uuid)
    })
}

const cancelReferenceIndex = (data) => {
    rentingService.cancelReferenceIndex(data.tri.renting_uuid)
    .then(() => {
        referenceIndexes.value.find((o, i) => {
            if(o.uuid === data.uuid) {
                referenceIndexes.value.splice(i, 1)

                return true
            }
        })

        taskService.modify(data.uuid, {
            status: 2
        })
        .then(() => {
            props.data.status = 2

            emit('changeTask', data.uuid)
        })
    })
}

onMounted(() => {
    dataStore.getReferenceIndexes()
        .then(response => referenceIndexes.value = response)

    rentingService.getInstance(props.data.tri.renting_uuid)
    .then((data) => {
        renting.value = data.data

        referenceIndexService.get({params: {sort: 'period', desc: 'period'}})
        .then(response => {
            const foundIRL = response.find((o, i) => {
                if(o.id == renting.value.reference_index_id) {
                    return true
                }
            })
            referenceIndex.value = foundIRL

            const re = /([0-9]{4})-T([1-4]{1})/.exec(foundIRL.period)

            const found = response.find((o, i) => {
                if(o.period.includes(re[2])) {
                    return true
                }
            })

            newRI.value = found

            loading.value = true
        })
        //.catch()
    })
})

</script>

<template>

<div class="px-20 py-4">
    <ReferenceIndexWidgetEditModal
        :externVisible="referenceIndexEditDialog"
        :externReferenceIndex="referenceIndexToEdit"
        @edit="editReferenceIndexEnd"
        @close="referenceIndexEditDialog = false"
    />

    <div v-if="loading">
        <div v-if="data.status == 0" class="mt-2 line flex flex-row justify-between">
            <div>
                {{ renting.rent }}&nbsp;€ x {{ newRI.irl_index }} ({{ newRI.period }}) / {{ referenceIndex.irl_index }} ({{ referenceIndex.period }})
                <br />
                (Ancien loyer x Nouvel indice / Ancien indice)
            </div>
            <div>
                <span class="font-bold">{{ (renting.rent * newRI.irl_index / referenceIndex.irl_index).toFixed(2) }}&nbsp;€</span>
                <br />
                <span>arrondi à {{ Math.round(renting.rent * newRI.irl_index / referenceIndex.irl_index) }}&nbsp;€</span>
            </div>
            <div class="flex gap-1 my-auto h-8">
                <button class="rounded border border-black cursor-pointer my-auto px-1.5 py-1 shadow-md hover:shadow-none hover:bg-green-500" @click="editReferenceIndex(data)" title="Modifier l'index de référence">
                    <Icon name="edit" :size="12" color="black" class="w-4 h-4" />
                </button>
                <button class="rounded border border-black cursor-pointer my-auto px-1.5 py-1 shadow-md hover:shadow-none hover:bg-green-500" @click="updateReferenceIndex(data)" title="Appliquer l'index de référence">
                    <Icon name="valid" :size="12" color="black" class="w-4 h-4" />
                </button>
                <button class="rounded border border-black cursor-pointer my-auto px-1.5 py-1 shadow-md hover:shadow-none hover:bg-red-500" @click="cancelReferenceIndex(data)" title="Annuler l'index de référence">
                    <Icon name="cancel" :size="12" color="black" class="w-4 h-4" />
                </button>
            </div>
        </div>
        <div v-else="" class="mt-2 line flex flex-row justify-between">
            Loyer : {{ renting.rent }}&nbsp;€
            <br />
            Indice : {{ referenceIndex.irl_index }} ({{ referenceIndex.period }})
        </div>
    </div>
    <div v-else class="mx-4 w-full flex justify-center">
        <ProgressSpinner
            style="width: 50px; height: 50px"
            strokeWidth="5"
            fill="transparent"
            animationDuration="2.5s"
            aria-label="Custom ProgressSpinner"
            class="m-auto"
        />
    </div>
</div>

</template>
